import React, { useReducer } from 'react'
import { initialState, ProfileContext, profileReducer } from './profile-context'

export const ProfileProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(profileReducer, initialState);
  const value = { state, dispatch };
  return (
    <ProfileContext.Provider value={value}>
      {children}
    </ProfileContext.Provider>
  )
}

